export default {
      id: "ic-plan-reparateurs-usage",
      viewBox: "0 0 40 40",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#ic-plan-reparateurs-usage",
      toString: function () {
        return this.url;
      }
    }